// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_23-6";
export var headerCell = "_23-2";
export var rowWrapper = "_23-4";
export var stickyAggregationCell = "_23-a";
export var stickyAggregationRow = "_23-7";
export var stickyColumnCell = "_23-9";
export var stickyColumnHeaderCell = "_23-8";
export var table = "_23-1";
export var virtualRowWrapper = "_23-5";
export var virtualTableContainer = "_23-0";
export var white = "_23-3";